<app-generic-popup
  [visible]="config"
  [title]="$safeNavigationMigration(config?.title)"
  [titleIcon]="$safeNavigationMigration(config?.titleIcon)"
  [content]="$safeNavigationMigration(config?.content)"
  [leftButtons]="config?.leftButtons ?? []"
  [buttons]="$safeNavigationMigration(config?.buttons)"
  [width]="config?.width ?? 500"
  (onHiding)="onHiding()"
></app-generic-popup>
